import User from "@/types/User";
import { ref } from 'vue';


const apiUrl = process.env.VUE_APP_DJANGO_BACKEND
const result = ref<User>()

export const acceptedTerms = async (accessToken: any, user_id: any): Promise<void> => {
    try {
        const response= await fetch(`${apiUrl}/api/users/${user_id}/terms/`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                 Authorization: `Bearer ${accessToken}`},
            body: JSON.stringify({accepted_terms: true})
    });

    if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
    }
            } catch (error) {
    console.error('Error sending PATCH request:', error);
    }
};


export const checkTerms = async (accessToken: any, user_id: any) => {
    try {
        const response = await fetch(`${apiUrl}/api/users/${user_id}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
        });
    
        if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
        }
    
        const result = await response.json();
    
        return result;
    } catch (error) {
        console.error('Error fetching user data:', error);
    }
    };


export const PrintPhoto = (selectedImage:string) => {
        const screenWidth = window.innerWidth;
        const screenHeight = window.innerHeight;

        const printWindowWidth = 800;
        const printWindowHeight = 350;

        const left = (screenWidth - printWindowWidth) / 2;
        const top = (screenHeight - printWindowHeight) / 2;

        const printWindow = window.open(
          '',
          '',
          `width=${printWindowWidth},height=${printWindowHeight},left=${left},top=${top}`
        );

        if (printWindow && printWindow.document) {
          printWindow.document.write(`
            <html>
              <head>
                <title>Print Image</title>
                <style>
                  @media print {
                    body {
                      margin: 0;
                      padding: 0;
                    }
                    img {
                      max-width: 100%;
                      height: auto;
                      display: block;
                      page-break-before: always;
                    }
                    /* Ensure there's no page break after the image */
                    body, html {
                      width: 100%;
                      height: 100%;
                      overflow: hidden;
                    }
                  }
                </style>
              </head>
              <body>
                <img src="${selectedImage}" alt="Image to print">
              </body>
            </html>
          `);

          printWindow.document.close();
          printWindow.print();


          setTimeout(() => {
            printWindow.close();
          }, 1);
        } else {
          console.error('Failed to open print window');
        }
      };